import { cmdClear, cmdImport } from '../consts';
import { configDeviceList, getDeviceCommandId } from '../config/devicesList';

export default (editor, config = {}) => {
    const { Commands } = editor;
    const txtConfirm = config.textCleanCanvas;

    configDeviceList.devices.forEach((device) => {
        Commands.add(getDeviceCommandId(device.id), {
            run: (ed) => ed.setDevice(device.name),
            stop: () => {},
        });
    });

    Commands.add(
        cmdClear,
        (e) => confirm(txtConfirm) && e.runCommand('core:canvas-clear')
    );

    const pfx = editor.getConfig('stylePrefix');
    const importLabel = '';
    const importCnt = '';

    editor.Commands.add(cmdImport, {
        codeViewer: null,
        container: null,

        run(editor) {
            const currentHtml = editor.getHtml();
            const currentCss = editor.getCss();
            const codeContent = currentCss
                ? `${currentHtml}\n<style>\n${currentCss}\n</style>`
                : currentHtml;

            const codeViewer = this.getCodeViewer();
            editor.Modal.open({
                title: 'Import Code',
                content: this.getContainer(),
            }).onceClose(() => editor.stopCommand(cmdImport));

            codeViewer.setContent(codeContent || '');
            codeViewer.refresh();
            setTimeout(() => codeViewer.focus(), 0);
        },

        stop() {
            editor.Modal.close();
        },

        getContainer() {
            if (!this.container) {
                const codeViewer = this.getCodeViewer();
                const container = document.createElement('div');
                container.className = `${pfx}import-container`;

                if (importLabel) {
                    const labelEl = document.createElement('div');
                    labelEl.className = `${pfx}import-label`;
                    labelEl.innerHTML = importLabel;
                    container.appendChild(labelEl);
                }

                container.appendChild(codeViewer.getElement());

                const btnImp = document.createElement('button');
                btnImp.type = 'button';
                btnImp.innerHTML = 'Import';
                btnImp.className = `${pfx}btn-prim ${pfx}btn-import`;
                btnImp.onclick = () => {
                    editor.Css.clear();
                    editor.setComponents(codeViewer.getContent().trim());
                    editor.Modal.close();
                };
                container.appendChild(btnImp);

                this.container = container;
            }

            return this.container;
        },

        getCodeViewer() {
            if (!this.codeViewer) {
                this.codeViewer = editor.CodeManager.createViewer({
                    codeName: 'htmlmixed',
                    theme: 'hopscotch',
                    readOnly: false,
                });
            }

            return this.codeViewer;
        },
    });
};
